import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import CarnetImageType from '../../../common/enums/carnetImageType';

@Injectable()
export class CarnetService {
  constructor(private http: HttpClient) {}

  downloadCarnet(
    policyNumber: string,
    idNumber: string,
    type: CarnetImageType,
    reference: number,
  ): Observable<Blob> {
    const url = `VehicleCarnet?idNumber=${idNumber}&policyNumber=${policyNumber}&reference=${reference}&frontOrBack=${type}`;
    return this.http.get(url, { responseType: 'blob' });
  }
}
